import { createAppWrap } from '../../../create_app_wrap';
import commonMixin from '../../../mixins/_common';
import setupMixin from './../mixin';
import deliveryShippingDataEditer from './_shipping-data-editer-component';
import deliveryGroupEditer from './_delivery-group-editer-component';
import cartLeadTimeEdit from './_cart-lead-time-edit-component';
import deliveryShippingDataDelete from './_shipping-data-delete-component';

const MAX_SHIPPINGS = 15;
const MAX_DELIVERY_GROUPS = 20;

const view = '[data-view="setup-delivery"]';
const init = () => {
    /**

     * Vueオブジェクト
     * @type {Vue|any}
     */
    createAppWrap({
        el: view,
        data() {
            return {
            };
        },
        mixins: [
            commonMixin,
            setupMixin
        ],
        components: {
            // 出荷予定日のパターンコンポーネント
            'cart-lead-time-edit': cartLeadTimeEdit,
            // 配送方法編集コンポーネント
            'delivery-shipping-data-editer': deliveryShippingDataEditer,
            // 配送グループ編集コンポーネント
            'delivery-group-editer': deliveryGroupEditer,
            // 配送送方法削除コンポーネント
            'delivery-shipping-data-delete': deliveryShippingDataDelete,
        },
        computed: {
            // 配送設定
            shippings: function () {
                return this.setup_data.shopShipping;
            },
            // 配送方法設定数
            shippingsCount: function () {
                return this.shippings.length;
            },
            // 配送方法設定が一つでもあるか
            hasShippings: function () {
                return (this.shippingsCount > 0);
            },
            // 配送方法設定が二つ以上あるか
            hasManyShippings: function () {
                return (this.shippingsCount > 1 || this.deliveryGroupsCount > 1);
            },
            // 配送方法が追加できるか
            canAddedShipping: function () {
                return (this.shippingsCount < MAX_SHIPPINGS);
            },
            // 配送グループ設定
            deliveryGroups: function () {
                if (typeof this.setup_data.shopDeliveryGroup === 'undefined') {
                    return [];
                }
                return this.setup_data.shopDeliveryGroup.map( (group) => {
                    // 自動管理の場合はdelivery_methodsにすべて配送方法を追加する
                    if (group.delivery_methods_auto_sync) {
                        group.delivery_methods = this.shippings.map( (shipping) => {
                            return shipping.no;
                        });
                    }
                    // ソート
                    group.delivery_methods.sort((a, b) => {return a - b;});
                    // 配送方法名リストを追加する
                    group.delivery_methods_name = group.delivery_methods.map( (id) => {
                        const index = this.shippings.findIndex(({no}) => no === id);
                        return this.shippings[index].postage;
                    });
                    return group;
                });
            },
            // 配送グループ設定数
            deliveryGroupsCount: function () {
                return this.deliveryGroups.length;
            },
            // 配送グループ設定が一つでもあるか
            hasDeliveryGroups: function () {
                return (this.deliveryGroupsCount > 0);
            },
            // 配送グループが追加できるか
            canAddedDeliveryGroup: function () {
                return (this.deliveryGroupsCount < MAX_DELIVERY_GROUPS);
            },
        },
        watch: {
            // 設定がなかったら一つ追加する
            deliveryGroups: function () {
                if (!this.hasDeliveryGroups) {
                    this.updateDeliveryGroup(0, this.getNewDeliveryGroupData('デフォルト設定'));
                }
            }
        },
        methods: {
            // 配送設定の新規作成
            addShipping: function () {
                this.$refs.delivery_shipping_data_editer.show(this.shippingsCount, {});
            },
            // 対象配送設定の編集
            editShipping: function (index) {
                this.$refs.delivery_shipping_data_editer.show(index, this.shippings[index]);
            },
            // 対象配送設定の削除
            deleteShipping: function (index) {
                this.$refs.delivery_shipping_data_delete.show(index);
            },
            // 配送設定を更新(子コンポーネントからの通知を想定)
            updateShipping: function (index, shipping) {
                this.setup_data.shopShipping[index] = shipping;
            },
            // 新規配送グループ設定データを返す
            getNewDeliveryGroupData: function (name) {
                return {
                    no: this.deliveryGroupsCount + 1,
                    postage_set_name: name,
                    delivery_methods_auto_sync: true,
                    delivery_methods: [],
                };
            },
            // 配送グループ設定の新規作成
            addDeliveryGroup: function () {
                this.$refs.delivery_group_editer.show(this.deliveryGroupsCount, this.getNewDeliveryGroupData('独自グループ' + this.deliveryGroupsCount));
            },
            // 対象配送グループ設定の編集
            editDeliveryGroup: function (index) {
                this.$refs.delivery_group_editer.show(index, this.deliveryGroups[index]);
            },
            // 配送グループ設定を更新(子コンポーネントからの通知を想定)
            updateDeliveryGroup: function (index, group) {
                this.setup_data.shopDeliveryGroup[index] = group;
            },
        },
    });
};

if (document.querySelector(view)) {
    init();
}
